import { Check } from 'lucide-react';
import { cn } from '@/utils/tailwind';
import { DISAPPOINTING_NEWS_OPTIONS } from '../_constants';

type Props = {
  selected: string;
  onSelect: (id: string) => void;
};

const DisappointingReasonList = ({ selected, onSelect }: Props) => {
  return (
    <div className="flex flex-col items-start gap-[16px]">
      {DISAPPOINTING_NEWS_OPTIONS.map(({ id, description }) => {
        const isSelected = selected === id;
        return (
          <button
            key={id}
            onClick={() => onSelect(isSelected ? '' : id)}
            className={cn(
              'flex h-[26px] w-full items-center justify-between Body1S16',
              isSelected ? 'text-point-500' : 'text-gr-700',
            )}
          >
            {description}
            {isSelected && <Check className="text-statusBlue-400" />}
          </button>
        );
      })}
    </div>
  );
};

export default DisappointingReasonList;
